import React from "react";

// Components
import BlockContent from "../components/richText";
import Columns from "../components/columns";
import Form from "../components/form";
import FurtherReadingLinks from "../components/furtherReadingLinks";
import Testimonial from "../components/testimonials/";
import TextImage from "../components/textImage";
import VideoEmbed from "../components/videoEmbed";
import ExperienceItems from "../components/experience/experienceItems";
import SpeakersCarousel from "../components/speakers/SpeakersCarousel";
import SpeakerSmallList from "../components/speakers/SpeakerSmallList";

//Constants
import { builderType } from "./constants";

//Styles
import * as styles from "../templates/blogsStyles.module.scss";
import * as pageStyles from "../pages/styles.module.scss";

const PAGE_BUILDER_CONTENT_TYPES = Object.freeze({
  aboutUs: (content) =>
    content?.aboutUs && (
      <div
        style={{
          padding: "0 5%",
          maxWidth: "1260px",
          width: "100%",
          margin: "0 auto",
        }}
      >
        <BlockContent blocks={content.aboutUs} />
      </div>
    ),
  columns: (content) => (
    <Columns key={content._key} {...content} type={builderType.columns} />
  ),
  form: (content) => <Form key={content._key} {...content} />,
  furtherReadingLinks: (content) => (
    <FurtherReadingLinks key={content._key} {...content} />
  ),
  pbRichText: ({ background, _key, richText }, className = "") => {
    return (
      <div
        key={_key}
        style={{
          backgroundColor: background,
          paddingLeft: "5%",
          paddingRight: "5%",
        }}
        className={className}
      >
        <BlockContent blocks={richText} />
      </div>
    );
  },
  testimonial: (content, className) =>
    className ? (
      <div key={content._key} className={className}>
        <Testimonial {...content} />
      </div>
    ) : (
      <Testimonial key={content._key} {...content} />
    ),
  textImage: (content, customClass) => (
    <TextImage className={customClass} key={content._key} {...content} />
  ),
  videoEmbed: (content, customClass) => (
    <VideoEmbed className={customClass} key={content._key} {...content} />
  ),
  pbExperience: (content) => {
    return (
      <>
        {content?.introText && (
          <div className={pageStyles.introWrapper}>
            <p>{content.introText}</p>
          </div>
        )}
        <div className={styles.mainContentWrapper}>
          <div className={styles.cardsWrapper}>
            <div className={styles.cards}>
              <ExperienceItems items={content?.experienceItems} />
            </div>
          </div>
        </div>
      </>
    );
  },
  speakers: (props) => {
    if (!props.speakers?.length) return null;

    return props.speakers.length > 3 ? (
      <SpeakersCarousel {...props} />
    ) : (
      <SpeakerSmallList {...props} />
    );
  },
});

export default PAGE_BUILDER_CONTENT_TYPES;
